module.exports = __webpack_public_path__ + "img/3.15ef9a7b.jpg";